import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-left" }
const _hoisted_2 = { class: "header-right" }

import { ref } from 'vue'
import { MenuOutlined } from '@ant-design/icons-vue'
import Sidebar from '@/components/Sidebar.vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderBar',
  setup(__props) {

const router = useRouter()
const showMobileNav = ref(false)

function toggleMobileNav () : void {
  showMobileNav.value = !showMobileNav.value
}

return (_ctx: any,_cache: any) => {
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        style: {"align-self":"center"},
        src: "/images/logos/Logo_Tuvast.png",
        width: "140",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/dashboard')))
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(MenuOutlined), {
        style: { fontSize: '18px' },
        onClick: toggleMobileNav
      }),
      _createVNode(_component_a_drawer, {
        title: "Navigatie",
        placement: "left",
        "body-style": { padding: '0' },
        visible: showMobileNav.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showMobileNav).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(Sidebar, { onCloseNav: toggleMobileNav })
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}
}

})